import { gql } from '@apollo/client';
import Fragments from './fragments';

export const FINANCIAL_INDICATOR_UPDATED = gql`
  subscription financialIndicatorUpdated {
    financialIndicatorUpdated {
      financialIndicator {
        ...financialIndicatorItem
      }
    }
  }
  ${Fragments.financialIndicatorItem}
`;
